import { render, staticRenderFns } from "./DatavMapEventList.vue?vue&type=template&id=265c2c7e&scoped=true&"
import script from "./DatavMapEventList.vue?vue&type=script&lang=js&"
export * from "./DatavMapEventList.vue?vue&type=script&lang=js&"
import style0 from "./DatavMapEventList.vue?vue&type=style&index=0&id=265c2c7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265c2c7e",
  null
  
)

component.options.__file = "DatavMapEventList.vue"
export default component.exports